/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { I18NDto } from '../../models/i-18-n-dto';
import { I18NUpdateDto } from '../../models/i-18-n-update-dto';

export interface I18NAdminControllerUpdateV1$Params {
  id: string;
      body: I18NUpdateDto
}

export function i18NAdminControllerUpdateV1(http: HttpClient, rootUrl: string, params: I18NAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<I18NDto>> {
  const rb = new RequestBuilder(rootUrl, i18NAdminControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<I18NDto>;
    })
  );
}

i18NAdminControllerUpdateV1.PATH = '/api/v1/i18n/admin/{id}';
